import { take, all, put, select } from "redux-saga/effects";
import {
  GET_NOTIFICATIONS,
  SET_NOTIFICATIONS_PAGE, SOCKET_SEND_TOKEN
} from "../actions/notificationActions";
import localForage from "localforage";
import getAxios from "../getAxios";

const getNotificationsSaga = function*() {
  while (true) {
    try {
      const { payload } = yield take(GET_NOTIFICATIONS);
      const { token } = yield localForage.getItem("account");
      const ax = yield getAxios(token);
      const { data } = yield ax.get(
        `${process.env.REACT_APP_API_URL}notifications/?page=${payload.page}`
      );
      yield put({
        type: SET_NOTIFICATIONS_PAGE,
        payload: {
          page: payload.page,
          data
        }
      });
    } catch (e) {}
  }
};

export const onSocketSendTokenSaga = function*() {
  while (true) {
    try {
      const action = yield take(SOCKET_SEND_TOKEN);
      const state = yield select();
      const token = state.auth.token;
      const ws = state.notification.ws;
      // TODO change token
      ws.send(
          JSON.stringify({
            command: 'authorization',
            token: token,
          }),
      );
    } catch (e) {
      // TODO catch e
    }
  }
};

export default function*() {
  yield all([getNotificationsSaga(), onSocketSendTokenSaga()]);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/notificationSaga.js